<div class="px-4 px-md-5 px-xxl-4">
  <div class="content-section">
    <div>
      <app-crumbs [crumbs]="crumbs"></app-crumbs>
    </div>
    <br>
    <div class="d-flex flex-column flex-lg-row">
      <div class="container-fluid px-0 px-xl-2">
        <img [src]="productRecipe.image" class="w-100 image-product filters" style="object-fit: cover;" alt="">
      </div>
      <div class="content-description w-100 py-4 px-0 px-lg-4 px-xl-5">
        <div>
          <span class="fw-extrabold fs-5">{{productRecipe.title}}</span>
        </div>
        <hr>
        <div>
          <span class="fw-regular">{{productRecipe.descripcion}}</span>
        </div>
        <br>
        <div class="d-flex flex-column">
          <div *ngFor="let bullet of productRecipe.bullets.slice(0,1)" class="d-flex al-center">
            <img [src]="bullet.icon" class="me-3" alt="">
            <span class="fw-regular">{{bullet.name}}</span>
          </div>
        </div>
        <br>
        <div>
          <span class="fw-extrabold fs-5">{{general.detail[0]}}</span>
        </div>
        <hr>
        <div class="d-flex flex-column mb-3">
          <div *ngFor="let ingredient of productRecipe.ingredients" class="d-flex al-center mb-3">
            <img src="assets/svg/bullet.svg" width="12" class="me-3" alt="">
            <span class="fw-regular">{{ingredient}}</span>
          </div>
        </div>
        <div>
          <span class="fw-extrabold fs-5">{{general.detail[1]}}</span>
        </div>
        <hr>
        <div class="d-flex">
          <div>
            <img src="assets/svg/bullet.svg" width="12" class="me-3" alt="">
          </div>
          <span class="fw-regular">{{productRecipe.preparation}}</span>
        </div>
      </div>
    </div>
    <br><br><br>
    <ng-container *ngIf="recommendedRecipes.length > 0">
      <div>
        <span class="fs-1 fw-extrabold text-blue">{{general.detail[2]}}</span>
      </div>
      <br>
      <app-recipe [products]="recommendedRecipes.slice(0,3)" (showProduct)="getRecipe($event)"></app-recipe>
      <br><br><br>
    </ng-container>
  </div>
</div>
